// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__2vle_"};